import app from "flarum/forum/app";
import { adoptChannelPayload } from "./invitations";

/**
 * Handing a channel to another member.
 *
 * Three steps on the server (see Service\OwnershipTransfers): the owner starts
 * it and is mailed a code, enters the code, and the member accepts or declines.
 * Every step answers with the channel and its members, pushed into the store
 * here, so whichever surface acted (the members tab, the notification row)
 * redraws from the server's answer rather than from a guess.
 *
 * The code is only ever typed by the owner and posted once; nothing here keeps
 * it, logs it or puts it in the store.
 */

async function transferRequest(channelId, step, attributes) {
  if (attributes === void 0) {
    attributes = {};
  }
  const payload = await app.request({
    method: "POST",
    url: "".concat(app.forum.attribute("apiUrl"), "/chat-channels/").concat(channelId, "/transfer").concat(step),
    body: {
      data: {
        attributes
      }
    },
    // Every caller shows the server's answer itself (a wrong code says how
    // many attempts remain); core's default alert on top would show it twice.
    errorHandler: () => undefined
  });
  return adoptChannelPayload(payload);
}
export function startTransfer(channelId, userId) {
  return transferRequest(channelId, "", {
    userId
  });
}
export function confirmTransfer(channelId, code) {
  return transferRequest(channelId, "/confirm", {
    code
  });
}
export function cancelTransfer(channelId) {
  return transferRequest(channelId, "/cancel");
}
export function acceptTransfer(channelId) {
  return transferRequest(channelId, "/accept");
}
export function declineTransfer(channelId) {
  return transferRequest(channelId, "/decline");
}
flarum.reg.add('ramon-chat', 'forum/utils/transfers', { startTransfer: startTransfer,confirmTransfer: confirmTransfer,cancelTransfer: cancelTransfer,acceptTransfer: acceptTransfer,declineTransfer: declineTransfer, });